import script from "./PlayerCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayerCard.vue?vue&type=script&setup=true&lang=ts"

import "./PlayerCard.vue?vue&type=style&index=0&id=0ed525e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ed525e8"]])

export default __exports__